import { accountState } from '@/app/model/store/domain/types.ts'

export default {
  setAccountList (state: accountState, payload: any) {
    state.accountData = payload
  },
  setAllFieldData (state: accountState, payload: any) {
    state.allFieldData = payload
  },
  setChoiceAccountType (state: accountState, payload: number) {
    state.choiceAccountType = payload
  },
  setSearchText (state: accountState, payload: string) {
    state.searchText = payload
  },
  setSortName (state: accountState, name: string) {
    state.sortName = name
  },
  setSortAsc (state: accountState, asc: boolean) {
    state.sortAsc = asc
  }
}
